// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bottom_box":"bottom_box-3o926J4X"};